/**
 * 시딩 신청/수락 POST 가 "활성 패널티" 로 거절될 때 BE 가 내려주는 전용 에러 코드. (QAT-39734, BE 0619)
 * 기존엔 패널티 거절이 공용 `COMMON-001-003`(over-limit)과 섞여 구분 불가했으나, 전용 코드 분리로
 * 토스트가 아니라 PENALTY 다이얼로그(RecruitApplyValidationDialog PENALTY, Figma 1476-31970)로 안내 가능.
 *
 * 선제 검증(detail.penalty)을 우회한 race(상세 로드 후 패널티 활성화 등) 폴백 경로다.
 */
export const ERROR_CODE_SEEDING_PENALTY = 'SEEDING-001-010';

/**
 * mutation onError 로 들어온 에러가 "활성 패널티 거절(SEEDING-001-010)" 인지 판정한다.
 *
 * non-2xx HTTP 응답만 대상. `executeStandardRequest` 가 non-2xx 를 `{ data, status, message }`
 * 평문 객체로 reject 하며 BE errorCode 는 `error.data.meta.errorCode` 경로에 담긴다.
 * (over-limit `SEEDING-001-009` 와 동일 엔드포인트·동일 transport — [[isSeedingCampaignOverLimitError]] 와 동형.)
 */
export const isSeedingPenaltyError = (error: unknown): boolean => {
  if (typeof error !== 'object' || error === null || !('data' in error)) return false;
  const { data } = error as { data?: unknown };
  if (typeof data !== 'object' || data === null || !('meta' in data)) return false;
  const { meta } = data as { meta?: unknown };
  if (typeof meta !== 'object' || meta === null || !('errorCode' in meta)) return false;
  const { errorCode } = meta as { errorCode?: unknown };
  return errorCode === ERROR_CODE_SEEDING_PENALTY;
};
